import { getCandidateProfile } from "../../../services/academyApi";

export const CREATOR_CONTACT_FIELDS = [
  { key: "firstname", label: "first name" },
  { key: "lastname", label: "last name" },
  { key: "mobilenumber", label: "mobile number" },
];

export function missingCreatorContactFields(candidate = {}) {
  return CREATOR_CONTACT_FIELDS.filter(({ key }) => {
    const value = candidate[key];
    return value === null || value === undefined || String(value).trim() === "";
  }).map((field) => field.key);
}

export function creatorProfilePath(nextPath = "/me/creator") {
  const safe =
    typeof nextPath === "string" && nextPath.startsWith("/me/creator")
      ? nextPath
      : "/me/creator";
  return `/me/profile?next=${encodeURIComponent(safe)}`;
}

export function isSafeCreatorNext(path) {
  return typeof path === "string" && path.startsWith("/me/creator");
}

export async function loadCreatorContactStatus() {
  const data = await getCandidateProfile();
  const candidate = data.candidate || {};
  const missing = missingCreatorContactFields(candidate);
  return {
    candidate,
    missing,
    complete: missing.length === 0,
    profilePath: creatorProfilePath("/me/creator"),
  };
}

export function redirectToCreatorProfile(nextPath) {
  window.location.href = creatorProfilePath(nextPath);
}

export function handleCreatorProfileError(error, fallbackNext = "/me/creator") {
  if (error?.code === "profile_incomplete") {
    window.location.href = error.profile_path || creatorProfilePath(fallbackNext);
    return true;
  }
  if (error?.code === "license_required") {
    const next =
      typeof fallbackNext === "string" && fallbackNext.startsWith("/me/creator")
        ? fallbackNext
        : "/me/creator";
    window.location.href = `/creator/license?next=${encodeURIComponent(next)}`;
    return true;
  }
  return false;
}
